module.exports = __webpack_public_path__ + "/login_ui/img/george-50e4242c4234f72afe4d320c5c930aec.svg";